<div class="d-flex flex-column page-header">
  <div class="d-flex p-2 flex-wrap">
    <div>
      <p class="title">Run PI History Data</p>
      <a routerLinkActive="active" (click)="runParameterDialog()" title="New Run" class="btn font-weight-bold runBtn">Run</a>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="row mt-2">
    <div id="searchBar" class="col-2 col-md-2 col-sm-2 col-xs-2 mb-1">
      <div class="parameterOption margin-left-0">
        <input type="text" class="form-control fixed-height-search regularText" (keyup)="globalService.applyFilter($event.target.value, runList)" placeholder="Search">
        <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
      </div>
    </div>
    <div class="col-8 col-sm-8 col-md-8 col-lg-8 mb-1 regularText">
      <mat-chip-listbox #chipList>
        <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
          {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
    <div class="col-2 col-sm-2 col-md-2 co-lg-2 regularText">
      <div class="exportIcon iconSize imgAddScenario textRightExport display-block margin-right-129 ml-1" (click)="exporterPiHistory.exportTable('xlsx', {fileName:'PiHistory', sheet: 'PiHistory'})">&nbsp;</div>
      <div class="filterIcon iconSize imgAddScenario textRightExport display-block" placement="bottom-right" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth">&nbsp;</div>
    </div>
  </div>
  <div class="fixed-height">
    <mat-table #grid matTableExporter [dataSource]="runList" #runsTableSort="matSort" matSort matSortDisableClear (exportStarted)="isLoader = true" (exportCompleted)="isLoader = false"  #exporterPiHistory="matTableExporter" hiddenColumns="[3, 4]">
      <ng-container matColumnDef="runBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">Run By</mat-header-cell>
        <mat-cell *matCellDef="let row" class="regularText"> {{row.runBy}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="runTime">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">
          <span class="col-head-span">Run Time</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="regularText"> {{row.runAt}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="lastCheckedStaus">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">Last Status</mat-header-cell>
        <mat-cell *matCellDef="let row" class="regularText"
                  matTooltip={{row.errorDescription}} matTooltipPosition="above" matTooltipclass="tooltip">
          <ng-container *ngIf="row.status == 'Succeeded'">
            <mat-icon class="green-icon">check_circle</mat-icon><span class="icon-text-align">{{row.status}}</span>
          </ng-container>
          <ng-container *ngIf="row.status == 'Failed'">
            <mat-icon class="red-icon">cancel</mat-icon><span class="icon-text-align">{{row.status}}</span>
          </ng-container>
          <ng-container *ngIf="row.status == 'InProgress'">
            <mat-icon>rotate_right</mat-icon><span class="icon-text-align">{{row.status}}</span>
          </ng-container>
          <ng-container *ngIf="row.status == 'Queued'">
            <mat-icon>query_builder</mat-icon><span class="icon-text-align">{{row.status}}</span>
          </ng-container>
          <ng-container *ngIf="row.status == 'Cancelled'">
            <mat-icon class="red-icon">cancel</mat-icon><span class="icon-text-align">{{row.status}}</span>
          </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="parameters">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="heading2">
          <span class="col-head-span">Parameters</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="regularText wb">
          <a class="pointer pl-15" (click)="viewParameterDilog(row.parameters)" title="Parameters"><mat-icon>visibility</mat-icon></a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef class="heading2 TitleMatAction">
          <a class="pointer" (click)="refreshAllRuns()" title="Refresh All status"><mat-icon>refresh</mat-icon></a>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="TitleMatAction regularText">
          <ng-container *ngIf="row.status != 'Succeeded'">
            <span>
              <a class="pointer pl-10" (click)="checkRun(row)" title="Refresh status"><mat-icon>refresh</mat-icon></a>
            </span>
          </ng-container>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>
  </div>
  <div *ngIf="noData | async" class="no-rec">
    No records found
  </div>
  <div class="row">
    <div class="col-md-12 text-center" *ngIf="isLoader==true">
      <div class="loader"></div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 col-lg-3"></div>
    <div class="col-md-9 col-lg-9">
      <mat-paginator #runsPaginator class="flex-wrap"
                     [pageSize]="10"
                     [pageSizeOptions]="[10, 50, 75, 100]" ngClass="{{firstTableClass}}">
      </mat-paginator>
    </div>
  </div>

  <ng-template #addFilter><app-add-filter [filterList]="filterList" [application]="'piHistory'" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>

</div>
